import SunEditor from 'suneditor-react'
import AxiosInstance from 'utils/AxiosInstance'
import './styles.css'

function TextEditor({
  isOpen,
  setIsOpen,
  textContent,
  onChangeText,
  placeholder,
  ...props
}) {
  const handleChange = (newContent) => {
    onChangeText(newContent)
  }

  const handleImageUploadBefore = (files, info, uploadHandler) => {
    const fileReader = new FileReader()
    const thumbFile = files[0]

    fileReader.readAsDataURL(thumbFile)

    const data = new FormData()
    data.append('file', thumbFile)

    AxiosInstance.post(`/courses/upload-question-file`, data).then((res) => {
      uploadHandler({
        result: [
          {
            name: res.fileName,
            size: thumbFile.size,
            url: res.url,
          },
        ],
      })
    })
  }

  const defaultOptions = {
    buttonList: [
      ['undo', 'redo', 'font', 'fontSize', 'formatBlock', 'list', 'fontColor'],
      [
        'fontColor',
        'hiliteColor',
        'outdent',
        'indent',
        'align',
        'horizontalRule',
        'list',
        'table',
      ],
      ['bold', 'underline', 'italic'],
      ['image', 'link', 'video', 'table'],
    ],
    styles: `
		.my-editor .se-wrapper-inner .se-editable {
		  border-radius: 90px;
		}
	  `,
  }

  return (
    <SunEditor
      placeholder={placeholder ? placeholder : ''}
      name='text-editor'
      className='rounded'
      imageUploadUrl='/image-upload'
      imageUploadHeader='multipart/form-data'
      setContents={textContent}
      onChange={handleChange}
      onImageUploadBefore={handleImageUploadBefore}
      height={300}
      disable={props.disable}
      setOptions={props.setOptions ? props.setOptions : defaultOptions}
    />
  )
}

export default TextEditor
